import {useMutation, useQuery, UseQueryOptions, UseQueryResult} from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys }     from './_query_keys'
import { HttpRequest }  from '../services/_http'
import { useState } from 'react'
export const usePermissionSubjects = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {
    
    const method   = 'GET'
    const queryKey = [QueryKeys.PERMISSIONS, searchOptions]
    
    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true) 
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.PermissionSubjects,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        keepPreviousData,
        onError: ()=>setkeepPreviousData(false),
        onSuccess: ()=>setkeepPreviousData(true),
        ...options
    })
}

export const useRolesData = (searchOptions?:any, options?: UseQueryOptions): UseQueryResult <any> => {
    
    const method   = 'GET'
    const queryKey = [QueryKeys.ROLES, searchOptions]
    
    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true) 
    
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.Roles,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus:false,
        keepPreviousData,
        onError: ()=>setkeepPreviousData(false),
        onSuccess: ()=>setkeepPreviousData(true),
        ...options
    })
}

export const useUpdateRole = (options?: any) => {
    
    const method = 'PUT'
    
    return useMutation(({data, role_id}: {data: any, role_id: any})=> HttpRequest({
        url: `${APIEndpoints.Roles}/${role_id}`,
        method,
        data
    }), options)
}

export const useAddRole = (options?: any) => {
    
    const method = 'POST'
    
    return useMutation(({data}: {data: any})=> HttpRequest({
        url: `${APIEndpoints.Roles}`,
        method,
        data
    }), options)
}

export const useDeleteRole = (options?: any) => {
    
    const method = 'DELETE'
    
    return useMutation(({role_id}: {role_id: any})=> HttpRequest({
        url: `${APIEndpoints.Roles}/${role_id}`,
        method,
    }), options)
}